import { getBaseQuery, getBaseUrl, REQUEST_TIMEOUT_MS } from '../api.util.ts'
import { createApi } from '@reduxjs/toolkit/query/react'
import {
  ClearBookAlertsRequest,
  GetBookDetailsRequest,
  GetBookDetailsResponse,
} from './book-api.def.ts'

const interfaceName = 'book'

export const bookApi = createApi({
  reducerPath: 'bookApi',
  baseQuery: getBaseQuery(getBaseUrl(interfaceName), REQUEST_TIMEOUT_MS),
  tagTypes: ['book'],
  endpoints: (build) => ({
    getBookDetails: build.query<GetBookDetailsResponse, GetBookDetailsRequest>({
      query: (params) => ({
        url: `/${params.id}`,
        method: 'GET',
        params: params,
      }),
    }),
    clearBookIdeaAlerts: build.query<void, ClearBookAlertsRequest>({
      query: (payload) => ({
        url: `/${payload.bookId}/alert/off`,
        method: 'POST',
        body: payload,
      }),
    }),
  }),
})

export const {
  useGetBookDetailsQuery,
  useLazyGetBookDetailsQuery,
  useLazyClearBookIdeaAlertsQuery,
} = bookApi
